<template>
  <div
    data-test-id="showtimes-by-screen"
  >
    <div
      v-if="showingsQuery.loaded && showingsByScreen.length == 0"
      class="message"
      style="margin: 100px 0px"
    >
      {{ $t('showing.noShowingsToday') }}
    </div>

    <div
      v-if="!showingsQuery.loaded"
      class="row justify-center"
    >
      <q-spinner
        size="md"
        color="grey"
      />
    </div>

    <!-- We have a showtimes-->
    <div
      v-else
      class="main-display"
    >
      <component
        :is="($register && allMovies) ? 'q-scroll-area' : 'div'"
        :class="($register && allMovies) ? 'absolute-full' : 'column full-width'"
        :style="($register && allMovies) ? 'margin-top: 65px; z-index: 0;' : 'margin-top: 15px;'"
      >
        <div
          v-for="showingByScreen in showingsByScreen"
          :key="showingByScreen.screen.id"
          class="col row content-center movie-container items-center justify-center"
          :class="{
            'no-background': true,
            'register': $register,
            'q-pt-xl q-pb-lg': !$register
          }"
          style="position: relative; overflow: hidden;"
        >
          <div
            style="writing-mode: vertical-rl;text-orientation: upright; z-index: 1; top: 10px; left: 12px;"
          >
            {{ showingByScreen.showings[0].screen.name }}
          </div>

          <div
            class="showings col row items-start q-pa-xs"
            style="min-width: unset;"
            :style="$register ? '' : 'max-width: 800px;'"
          >
            <div
              v-for="showing in showingByScreen.showings"
              :key="showing.id"
              class="col column q-my-xs q-mx-xs q-px-sm q-py-sm items-center justify-center background-banner"
              :style="`min-width: 120px; background: linear-gradient(rgba(255,255,255,0.7), rgba(255,255,255,0.7)), url('${showing.movie.bannerImageUrl}');`"
              @click="(event) => selectMovie(event, showing.movie)"
            >
              <div
                v-if="allMovies"
                class="text-h7 text-bold text-grey-10 text-center"
              >
                {{ showing.movie.name }}
              </div>
              <div>
                <div
                  v-if="$register"
                  style="display: grid;"
                  class="items-center justify-center"
                >
                  <showtimes-button-basic
                    :showing="showing"
                    :is-disabled="!allowPastShows && !showing.movie.allowPastSales && showing.localPast || (showing.showingFinished && !allowPastShows) || showing.seatsRemaining <= 0"
                    :has-multiple-screens="false"
                    hide-screen-name
                    @select-showing="showing => $emit('select-showing', showing)"
                    @show-held-seat-dialog="showHeldSeatDialog(showing)"
                  />
                  <showtime-attendance-bar
                    :showing="showing"
                    @click="showHeldSeatDialog(showing)"
                  />
                </div>
                <div
                  class="row justify-center items-center q-mt-sm"
                  @click="showHeldSeatDialog(showing)"
                >
                  <q-badge
                    v-if="$register"
                    class="q-mr-sm"
                    color="primary"
                  >
                    {{ showing.ticketsSold|| '0' }}
                    <q-tooltip
                      class="text-white"
                      style="background-color: rgba(0, 0, 0, 0.5)"
                    >
                      {{ $t('ticket.ticketsSold') }}
                    </q-tooltip>
                  </q-badge>
                  <q-badge
                    v-if="$register"
                    class="q-mr-sm"
                    style="padding: 3px 7px"
                    :color="availableColor(showing)"
                  >
                    {{ showing.seatsRemaining || '0' }}
                    <q-tooltip
                      class="text-white"
                      style="background-color: rgba(0, 0, 0, 0.5)"
                    >
                      {{ $t('ticket.ticketsRemaining') }}
                    </q-tooltip>
                  </q-badge>
                  <rated
                    v-if="showing.movie.rating"
                    :rated="showing.movie.rating"
                    :rating-reason="showing.movie.ratingReason"
                    dense
                    :outline="false"
                    :color="'primary'"
                    :size="$register ? 'xs' : 'md'"
                    class="q-py-sm"
                  />
                  <showing-badge
                    v-for="showingBadge in showing.showingBadges.data"
                    :key="showingBadge.id"
                    class="col-auto"
                    solid
                    :size="$register ? 'sm' : 'md'"
                    :dense="$register"
                    :showing-badge="showingBadge"
                  />
                  <q-chip
                    v-if="!$register && showing.isSoldOut"
                    square
                    color="transparent"
                    size="md"
                    style="border: solid 1px;"
                    :text-color="'negative'"
                    icon="people"
                    :label="$t('status.soldOut')"
                  />
                  <q-chip
                    v-else-if="!$register && currentSite.showConsumerAttendanceBadge && showAttendanceLevels && (showing.predictedAttendance < 7 || showing.predictedAttendance > 20)"
                    square
                    :color="solidShowingBadges ? (showing.predictedAttendance > 20 ? 'negative' : 'positive') : 'transparent'"
                    size="md"
                    style="border: solid 1px;"
                    :text-color="solidShowingBadges ? 'white' : (showing.predictedAttendance > 20 ? 'negative' : 'positive')"
                  >
                    <q-icon
                      name="people"
                      :text-color="showing.predictedAttendance > 20 ? 'negative' : 'positive'"
                      class="q-chip__icon material-icons q-icon notranslate"
                    />
                    <q-tooltip
                      class="text-white"
                      style="background-color: rgba(0, 0, 0, 0.5)"
                    >
                      {{ showing.predictedAttendance > 20 ?
                        ('We are projecting a high turn out for this showing! Suggest arriving ' + Math.round(Math.max(showing.predictedAttendance / 3, 10)) + ' minutes before the start time.') :
                        'Low projected attendance level, this is a great show to attend, beat the crowds!'
                      }}
                    </q-tooltip>
                  </q-chip>
                </div>
              </div>
            </div>
            <q-inner-loading :showing="showingsQuery.loading && !reloading" />
          </div>
        </div>
      </component>
    </div>
  </div>
</template>

<script>
import ShowingBadge from 'src/modules/admin/showing-badge/components/ShowingBadge.vue'
import Rated from 'src/modules/consumer/components/Rated'
import ShowtimeAttendanceBar from 'src/modules/consumer/components/ShowtimeAttendanceBar.vue'
import ShowtimesButtonBasic from 'src/modules/consumer/components/ShowtimesButtonBasic'
export default {
  name: 'ShowtimesByScreen',
  components: {
    ShowingBadge,
    ShowtimeAttendanceBar,
    Rated,
    ShowtimesButtonBasic
  },
  configuration: ['currentSite'],
  props: {
    showingsByScreen: {
      type: Array,
      required: true
    },
    showingsQuery: {
      type: Object,
      required: true
    },
    allMovies: {
      type: Boolean,
      required: true
    },
    solidShowingBadges: {
      type: Boolean,
      required: false,
      default: false
    },
    showAttendanceLevels: {
      type: Boolean,
      required: false,
      default: true
    },
    allowPastShows: {
      type: Boolean,
      required: false,
      default: false
    },
    reloading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['select-showing', 'common-showing-badges', 'edit-held-seats', 'select-movie'],
  methods: {
    commonShowingBadges (showings) {
      if (!showings || !showings.length) return []

      const commonShowingBadges = _.filter(showings[0].showingBadges.data, showingBadge => {
        return _.every(showings, showing => _.some(showing.showingBadges.data, { id: showingBadge.id }))
      })

      this.$emit('common-showing-badges', commonShowingBadges)

      return commonShowingBadges
    },
    showHeldSeatDialog (showing) {
      if (this.$register) this.$emit('edit-held-seats', showing)
    },
    availableColor (showing) {
      const ratio = showing.seatsRemaining / (showing.screen.seatCount - showing.heldSeatCount)

      if (ratio < 0.25) {
        return 'negative'
      } else if (ratio < 0.5) {
        return 'warning'
      } else {
        return 'positive'
      }
    },
    socialDistanceCount (showing) {
      return showing.seatsRemainingWithoutSocialDistancing - showing.seatsRemaining
    },
    selectMovie (event, movie) {
      if (event.target.clientHeight >= 180) this.$emit('select-movie', movie)
    },
    distinctShowingBadges (showings, showing) {
      return _.without(showing.showingBadges.data, ...this.commonShowingBadges(showings))
    },
    colorForShowing (showing) {
      if (showing.past) {
        return 'grey'
      }

      const ratio = showing.ticketsSold / (showing.ticketsSold + showing.seatsRemaining)
      if (ratio < 0.5) {
        if (showing.current) return 'green'
        return 'grey'
      }
      if (ratio < 0.7) return 'orange'
      return 'red'
    },
    multipleScreens (showing, showings) {
      return _.filter(showings, other => other.siteTime.getTime() === showing.siteTime.getTime()).length > 1
    }
  }
}
</script>

<style lang="scss" scoped>
.main-display {
  display: flex;
  flex-direction: row;

  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.movie-container.no-background {
  background-color:rgba(150, 150, 150, 0.2);
}
.movie-container.no-background:nth-child(odd) {
  background-color:rgba(150, 150, 150, 0.3);
}

.poster {
  width: 200px;
  max-width: 200px;
  border-radius: 7px;
  margin: 5px;
}
.movie-name {
  max-width: 200px;
  font-size: 18px;
  padding: 7px;
}

.poster.register {
  width: 120px;
  border-radius: 0px;
}

.background-banner {
  background-size: cover !important;
  border-radius: 5px;
}

.message {
  font-size: 32px;
  text-align: center;
}
</style>
